export default __webpack_public_path__ + "static/media/TokenEditor.068ab35d.mp4";